// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hZl_","placeholdersHeader":"styles_placeholdersHeader__1yp13","editorStyle":"styles_editorStyle__2HrR0","placeholdersBox":"styles_placeholdersBox__2ul_p"};